import React, { useState, useEffect } from 'react';
import { watchPredictions } from '../../Config/matudb';
import { Search, Calendar, Clock, TrendingUp, CheckCircle, AlertCircle, X, Trophy, Award, Activity, Crown, Lock } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import RadioOnline from '../radio/RadioOnline';
import HomeFree from '../Banner/HomeFree';
import FreePay from '../Banner/HomeFree';
import Noticias from '../Banner/Noticias';
import PredictionCard from './PredictionCard';
import PartidosCarrusel from '../../Components/PartidosCarrusel';

const getCurrentDateTime = () => {
  const today = new Date();
  return today.toLocaleString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit', 
    hour: '2-digit',
    minute: '2-digit',
  }).replace(',', '');
};

const BetFree = ({ limit }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [predictions, setPredictions] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(getCurrentDateTime());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const today = currentDateTime.split(' ')[0];
    let freeRows = [];
    let liveRows = [];
    const publish = () => {
      const freeToday = freeRows.filter((prediction) => prediction.date === today);
      const liveNow = liveRows.filter((prediction) => prediction.isLive);
      setPredictions([...liveNow, ...freeToday]);
    };
    const stopFree = watchPredictions('abet', (rows) => {
      freeRows = rows;
      publish();
    });
    const stopLive = watchPredictions('abetlive', (rows) => {
      liveRows = rows;
      publish();
    });
    return () => {
      stopFree();
      stopLive();
    };
  }, [currentDateTime]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredPredictions = predictions.filter((prediction) =>
    prediction.homeTeam.name.toLowerCase().includes(searchTerm) ||
    prediction.awayTeam.name.toLowerCase().includes(searchTerm) ||
    prediction.prediction.toLowerCase().includes(searchTerm)
  );
 
  // Limitar las predicciones si se define un límite
  const predictionsToShow = limit ? filteredPredictions.slice(0, limit) : filteredPredictions;

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white sm:px-6 lg:px-8 pb-12">
        <div className="max-w-7xl mx-auto">
          {/* <SocialMediaBanner/> */}
          <RadioOnline />
          <HomeFree />
          {/* <Noticias/> */}
          {/* <PartidosCarrusel/> */}

          <h1 className="text-4xl font-extrabold text-center ">
            Consejos del día
          </h1>
          <p className="text-center text-gray-400 mb-10 flex justify-center items-center mt-2">
            <Calendar size={20} className="mr-2" />
            <span>{currentDateTime}</span>
          </p>

          <div className="mb-8 max-w-md mx-auto">
            <div className="relative m-2">
              <input
                type="text"
                placeholder="Buscar equipos o pronósticos..."
                className="w-full bg-gray-800 text-white border border-gray-700 rounded-full py-3 px-6 pl-12 focus:outline-none"
                value={searchTerm}
                onChange={handleSearch}
              />
              <Search
                className="absolute left-4 top-3.5 text-gray-400"
                size={20}
              />
            </div>
          </div>

          {predictionsToShow.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {predictionsToShow.map((prediction) => (
                <PredictionCard key={prediction.id} prediction={prediction} />
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-400 mt-8 p-8 bg-gray-800 rounded-lg shadow-lg">
              <TrendingUp size={48} className="mx-auto mb-4" />
              <p className="text-xl font-semibold mb-2">
                No hay pronósticos disponibles en este momento
              </p>
              <p>
                Vuelve a consultar más tarde o explora nuestro historial de
                predicciones para obtener más información.
              </p>
            </div>
          )}
        </div>
        <FreePay />
      </div>
    </>
  );
};

export default BetFree;
